<template>
    <b-row>
        <b-col>
            <b-card>
                <h4 class="card-title text-uppercase">
                    {{ $t('omt.gui.location-management.app-settings.label.push-notifications') }}
                </h4>

                <b-row class="mb-3">
                    <b-col>
                        <span>{{ pushNotificationStatus }} {{ subscriptionStatus  }}</span>
                    </b-col>
                </b-row>

                <b-row>
                    <div class="col">
                        <font-awesome-icon v-if="isSaving" icon="spinner" spin/>
                        <div v-else>
                            <b-btn @click="register" class="mr-2" variant="primary" :disabled="isSaving">
                                <span>{{ $t('omt.gui.general.action.subscribe') }}</span>
                            </b-btn>
                            <b-btn @click="unregister" class="mr-2" variant="secondary" :disabled="isSaving">
                                <span>{{ $t('omt.gui.general.action.unsubscribe') }}</span>
                            </b-btn>
                        </div>
                    </div>
                </b-row>

                <b-row>
                    <b-col cols="12" md="6" class="pt-4">
                    <video-embed type="vimeo" id="850913466" />
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import VideoEmbed from '@/components/VideoEmbed/VideoEmbed.vue';

export default {
    components: { VideoEmbed },
    name: "AppSettings",

    props: {
        location: {required: false},
    },

    data() {
        return {
            isSaving: false,
            isLoading: false,
            pushNotificationStatus: '',
            subscriptionStatus: '',
        }
    },

    computed: {
    },

    mounted() {
        let appId = this.$store.state.config['onesignal']['app_id'] ?? '';
        if (appId === '') {
            this.$alert('Pushmeldingen staan uit, neem contact op met OmniStock', 'warning', true)
            return;
        }

        this.$OneSignal.init({
            appId: appId,
        });
        this.refreshSubscriptionStatus();
    },

    methods: {
        register() {
            this.isSaving = true;

            this.$OneSignal.showNativePrompt().then(function(result) {
                console.info('showNativePrompt', result)
            });

            this.$OneSignal.setSubscription(true).finally((result) => {
                console.info('setSubscription', result);
                this.$OneSignal.sendTag('shop', this.location.identifier).then((result) =>  {
                    console.info('sendtag', result)
                });
            });

            setTimeout(() => {
                this.refreshSubscriptionStatus()
                this.isSaving = false;
            }, 500)
        },

        unregister() {
            this.isSaving = true;
            this.$OneSignal.setSubscription(false);
            this.$OneSignal.sendTag('shop', null);

            setTimeout(() => {
                this.refreshSubscriptionStatus()
                this.isSaving = false;
            }, 500)
        },

        refreshSubscriptionStatus() {
            this.$OneSignal.isPushNotificationsEnabled().then((a) => {
                if (a) {
                    this.pushNotificationStatus = "Uw browser ontvangt pushmeldingen."
                } else {
                    this.pushNotificationStatus = "Uw browser ontvangt geen pushmeldingen."
                }
            });

            if (!this.$OneSignal.getSubscription()) {
                this.subscriptionStatus = "U bent niet aangemeld."
                return;
            }

            this.$OneSignal.getTags().then((tags) => {
                if (!tags || !tags.shop) {
                    this.subscriptionStatus = "U bent niet aangemeld."
                    return;
                }
                this.subscriptionStatus = `U bent aangemeld voor ${tags.shop}.`;
            });
        },

    },
}
</script>
